import { axiosInstance } from "./config";

export const getOrders_req = async (
  statusCode,
  startDate,
  endDate,
  consumerId
) => {
  const params = {};

  if (statusCode) params.status = statusCode;
  if (startDate) params.since = startDate;
  if (endDate) params.until = endDate;

  if (consumerId) params.consumerId = consumerId;
  const query = new URLSearchParams(params).toString();

  const url = query ? `/data-access/orders?${query}` : `/data-access/orders`;

  const response = await axiosInstance.get(url);

  return response?.data;
};

export const getSubscriptions_req = async (frequency, state, sku) => {
  const params = {};

  if (frequency) params.frequency = frequency;
  if (state) params.state = state;
  if (sku) params.sku = sku;
  const query = new URLSearchParams(params).toString();
  const url = query
    ? `/data-access/subscriptions?${query}`
    : `/data-access/subscriptions`;
  const response = await axiosInstance.get(url);

  return response?.data;
};

export const getCustomOrderById_req = async (orderId) => {
  const response = await axiosInstance.get(
    `/data-access/orders/${orderId}/full-report`
  );

  return response?.data;
};
